import script from "./pConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./pConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./pConfirmDialog.vue?vue&type=style&index=0&id=4c018256&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c018256"]])

export default __exports__